var _rect, _mask, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.206177,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#1C6947"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_9638_4750",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.90137 7.80774H11.3154V8.61633H8.90137V11.1124H8.08691V8.61633H5.68457V7.80774H8.08691V5.29993H8.90137V7.80774Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.90137 7.80774H11.3154V8.61633H8.90137V11.1124H8.08691V8.61633H5.68457V7.80774H8.08691V5.29993H8.90137V7.80774Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90137 7.80774H7.90137V8.80774H8.90137V7.80774ZM11.3154 7.80774H12.3154V6.80774H11.3154V7.80774ZM11.3154 8.61633V9.61633H12.3154V8.61633H11.3154ZM8.90137 8.61633V7.61633H7.90137V8.61633H8.90137ZM8.90137 11.1124V12.1124H9.90137V11.1124H8.90137ZM8.08691 11.1124H7.08691V12.1124H8.08691V11.1124ZM8.08691 8.61633H9.08691V7.61633H8.08691V8.61633ZM5.68457 8.61633H4.68457V9.61633H5.68457V8.61633ZM5.68457 7.80774V6.80774H4.68457V7.80774H5.68457ZM8.08691 7.80774V8.80774H9.08691V7.80774H8.08691ZM8.08691 5.29993V4.29993H7.08691V5.29993H8.08691ZM8.90137 5.29993H9.90137V4.29993H8.90137V5.29993ZM8.90137 8.80774H11.3154V6.80774H8.90137V8.80774ZM10.3154 7.80774V8.61633H12.3154V7.80774H10.3154ZM11.3154 7.61633H8.90137V9.61633H11.3154V7.61633ZM7.90137 8.61633V11.1124H9.90137V8.61633H7.90137ZM8.90137 10.1124H8.08691V12.1124H8.90137V10.1124ZM9.08691 11.1124V8.61633H7.08691V11.1124H9.08691ZM8.08691 7.61633H5.68457V9.61633H8.08691V7.61633ZM6.68457 8.61633V7.80774H4.68457V8.61633H6.68457ZM5.68457 8.80774H8.08691V6.80774H5.68457V8.80774ZM9.08691 7.80774V5.29993H7.08691V7.80774H9.08691ZM8.08691 6.29993H8.90137V4.29993H8.08691V6.29993ZM7.90137 5.29993V7.80774H9.90137V5.29993H7.90137Z",
    fill: "white",
    mask: "url(#path-2-inside-1_9638_4750)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFilled);
export default __webpack_public_path__ + "res/media/addFilled.587938310b76b60ed7e333f54fb9cb51.svg";
export { ForwardRef as ReactComponent };